///<reference path="../utils.ts"/>
import {Component, DoCheck, OnChanges, OnInit} from '@angular/core';
import {ReportComponent} from "../report/report.component";
import {Report} from "../report/report";
import {Utils} from "../utils";

declare var $: any;


@Component({
    selector: 'app-report-access',
    templateUrl: './report-access.component.html',
    styleUrls: ['./report-access.component.css']
})
export class ReportAccessComponent extends ReportComponent implements OnInit, DoCheck {

    report_index;
    request = {};
    campos;
    index;
    table;

    ngDoCheck(): void {
        super.ngDoCheck();
    }

    title = "Relatórios";


    ngOnInit() {
        this.report_index = null;
        this.model = [];

        this.validar_login();
		if (this.isAdmin()) {
			this.route.params.subscribe(params => this.index = +params['index']);
			this.get();
		} else
			this.router.navigateByUrl('inicio');
    }

    get() {
        this.spinnerService.show();
        this.service.get().then(response => {
            this.model = response;

            this.spinnerService.hide();
            // if (this.index || this.index===0) {
            if (this.index) {
                $('#report').prop('value', this.index);
                this.report_index = this.index;
                this.execute(this.index);
                //
            }
            // $('#report').hide();

            // }
        });

    }

    change(index) {
        this.router.navigateByUrl('report-access/' + index);

    }

    /**
     * Enviar o Id do relatório que deseja executar
     * @param id
     */
    execute(index) {

        index = index - 1;
        $('#report').prop('disabled', true);

        this.title = this.model[index].description;
        this.campos = Utils.explode(this.model[index].campos);

        let model = this.model[index];
        if (model.campos == '' || model.campos == null) {
            this.request = {}
        }

        this.service.execute(model.id, this.request).then(
            result => {
                let col = model.colunas;

                result = result.dados;
                //Fazendo dessa forma pois por algum motivo não estou tendo acesso para função length
                let colunas = Utils.explode(col);
                //adiciona ao inicio
                colunas.unshift('LINHA');

                if (this.table) {
                    this.table = $('#example').DataTable();
                    this.table.clear();
                    this.table.destroy();
                    this.table = $('#example').DataTable({
                        language: {
                            // "url": "https://cdn.datatables.net/plug-ins/1.10.12/i18n/Portuguese-Brasil.json"
                            "sEmptyTable": "Nenhum registro encontrado",
                            "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
                            "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                            "sInfoFiltered": "(Filtrados de _MAX_ registros)",
                            "sInfoPostFix": "",
                            "sInfoThousands": ".",
                            "sLengthMenu": "_MENU_ resultados por página",
                            "sLoadingRecords": "Carregando...",
                            "sProcessing": "Processando...",
                            "sZeroRecords": "Nenhum registro encontrado",
                            "sSearch": "Pesquisar",
                            "oPaginate": {
                                "sNext": "Próximo",
                                "sPrevious": "Anterior",
                                "sFirst": "Primeiro",
                                "sLast": "Último"
                            },
                            "oAria": {
                                "sSortAscending": ": Ordenar colunas de forma ascendente",
                                "sSortDescending": ": Ordenar colunas de forma descendente"
                            }
                        },
                        destroy: true,
                        retrieve: true,
                        paging: true,
                        searching: true,
                        responsive: true,
                        data: this.set_dados(result),
                        columns: this.set_col(colunas),
                        dom: 'Bfrtip',
                        buttons: [
                            {
                                extend: 'copy',
                                text: 'Copiar',
                            },
                            {
                                extend: 'csv',
                                text: 'CSV',
                            },
                            {
                                extend: 'excel',
                                text: 'Excel',
                            },
                            {
                                extend: 'pdfHtml5',
								pageSize: 'A3',
								orientation: 'landscape',
                                text: 'PDF',
                            },
                            {
                                extend: 'print',
                                text: 'Imprimir',
                            },
                        ]
                    });
                } else {
                    this.table = $('#example').DataTable({
                        language: {
                            // "url": "https://cdn.datatables.net/plug-ins/1.10.12/i18n/Portuguese-Brasil.json"
                            "sEmptyTable": "Nenhum registro encontrado",
                            "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
                            "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                            "sInfoFiltered": "(Filtrados de _MAX_ registros)",
                            "sInfoPostFix": "",
                            "sInfoThousands": ".",
                            "sLengthMenu": "_MENU_ resultados por página",
                            "sLoadingRecords": "Carregando...",
                            "sProcessing": "Processando...",
                            "sZeroRecords": "Nenhum registro encontrado",
                            "sSearch": "Pesquisar",
                            "oPaginate": {
                                "sNext": "Próximo",
                                "sPrevious": "Anterior",
                                "sFirst": "Primeiro",
                                "sLast": "Último"
                            },
                            "oAria": {
                                "sSortAscending": ": Ordenar colunas de forma ascendente",
                                "sSortDescending": ": Ordenar colunas de forma descendente"
                            }
                        },
                        destroy: true,
                        retrieve: true,
                        paging: true,
                        searching: true,
                        responsive: true,
                        data: this.set_dados(result),
                        columns: this.set_col(colunas),
                        dom: 'Bfrtip',
                        buttons: [
                            {
                                extend: 'copy',
                                text: 'Copiar',
                            },
                            {
                                extend: 'csv',
                                text: 'CSV',
                            },
                            {
                                extend: 'excel',
                                text: 'Excel',
                            },
                            {
                                extend: 'pdfHtml5',
								pageSize: 'A3',
								orientation: 'landscape',
                                text: 'PDF',
                            },
                            {
                                extend: 'print',
                                text: 'Imprimir',
                            },
                        ]
                    });
                }


            }
        )
    }

    set_col(colunas) {

        let columns = [];
        // Definir as colunas
        for (let i = 0; i < colunas.length; i++) {
            columns[i] = {title: colunas[i]};
        }
        return columns

    }


    set_dados(dados) {

        let dataset = [];
        //Definir os dados
        for (let i = 0; i < dados.length; i++) {
            let remover;

            if (dados.length == 1) {
                dados.push(dados[i]);
                remover = true;
            }
            // get all object property names
            dataset[i] = Object.keys(dados[1])
            // iterate over them and generate the array
                .map(function (k) {
                    // generate the array element
                    return dados[i][k];
                });
            if (remover) {
                dados.splice(0, 1);
            }


        }
        return dataset;
    }


}



// WEBPACK FOOTER //
// ./src/app/report-access/report-access.component.ts